import './style.scss';
import { useState, useEffect,useRef } from 'react';
import { useTranslation } from "react-i18next";
import Utils from "../../shared/utils";
import CookieService from '../../shared/cookieService';
import forwardRef from 'react';

const PSPrivacyPopupSplash = (props: any) => {
    const { t } = useTranslation('splash');
    let count = useRef('new');
    const [state, setState] = useState({
        visible: props.opened,
        isAccepted:false,
        isClose:props.closed
    });
    
    useEffect(() => {
        if(count.current == 'new')
        {
            state.isClose=false;
            count.current ='load';
        }
      },[]);

      useEffect(() => {
            state.isClose=false;
            count.current ='load';
      },[]);

      
    /**
     * Close splash screen
     */
    const close = () => {
        Utils.setStateValue('visible', false, state, setState)
        Utils.setStateValue('isClose', true, state, setState)
        Utils.setStateValue('isAccepted', false, state, setState)
        count.current='close';
        window.localStorage.setItem(CookieService.SESSION_OPEN_AGREED_PRIVACY_OPENED,'false');
    }
    const privacyChk = (val: boolean) => {
        Utils.setStateValue('isAccepted', val, state, setState);
        count.current='new';
    }
    const Confirmed = () => 
    {
        window.localStorage.setItem(CookieService.SESSION_AGREED_PRIVACY,'true');
        window.localStorage.setItem(CookieService.SESSION_OPEN_AGREED_PRIVACY_OPENED,'false');
        Utils.setStateValue('visible', false, state, setState);
        Utils.setStateValue('isClose', true, state, setState)
    }


    return (
        (window.localStorage.IUCN_OPEN_AGREED_PRIVACY=='true')  ?
    //    (!state.isClose && (count.current=='new' || count.current=='close'))  ?
            <div className="CountryGuildLineSplash">
                <div className="row shadow-lg p-3 mb-5 bg-white big-border-radius splashContent" >
                    <div className='contentDiv'>
                        <div>
                            <b className='psPrivacyBold'>{t('PSPrivacy_tile')} </b>
                        </div>

                        <div style={{ marginTop: `20px` }}>
                            {t('PSPrivacy_Subtile')}
                        </div>
                        <div style={{ marginTop: `20px` }}>
                            {t('PSPrivacy_TermsHeading')}

                        </div>
                        <div>
                            <ul>
                                <li className='psPrivacyLi'>
                                    {t('PSPrivacy_Terms1')}
                                </li>
                                <li className='psPrivacyLi'>
                                    {t('PSPrivacy_Terms2')}
                                </li>
                                <li className='psPrivacyLi'>

                                    {t('PSPrivacy_Terms3')}
                                </li>
                                <li className='psPrivacyLi'>
                                    {t('PSPrivacy_Terms4')}
                                </li>
                                <li className='PSPrivacyTerms5'>
                                    {t('PSPrivacy_Terms5')}
                                </li>
                            </ul>
                            <div style={{ marginTop: `20px` }}>
                                <span>
                                    <input className="form-check-input" type="checkbox" onChange={(e) => privacyChk(e.target.checked)}></input>
                                </span>
                                <span style={{ verticalAlign: `bottom` }}>&nbsp;{t('PSPrivacy_AgreeNote')}
                                </span>
                            </div>
                            <div style={{ fontSize: `12px`, marginTop: `20px` }}>{t('PSPrivacy_Contact')}
                                <span style={{ fontSize: `12px` }}> <a href='mailto:restoration@iucn.org'>{t('PSPrivacy_mailto')} </a> {t('PSPrivacy_Contact_Note')}</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: `20px`, float: 'left', width: '70%' }}></div>
                    <div style={{ marginBottom: `10px`, float: 'right', width: '30%' }}>
                    <span style={{ paddingRight: `10px` }}><button className="actionBtn primary" disabled={!state.isAccepted} onClick={() =>Confirmed()}>
                                <span>{t('PSPrivacy_btnConfirm')}</span>
                            </button>
                            </span>
                        <span>
                            <button className="actionBtn primary" onClick={close}>
                                <span>{t('PSPrivacy_btnCancel')} </span>
                            </button>
                        </span>
                    </div>
                </div>
            </div>

            : <div></div>
    )
};

export default PSPrivacyPopupSplash